import { render, staticRenderFns } from "./group-table.html?vue&type=template&id=0aa6633e&scoped=true&external"
import script from "./group-table.js?vue&type=script&lang=js&external"
export * from "./group-table.js?vue&type=script&lang=js&external"
import style0 from "./group-table.scss?vue&type=style&index=0&id=0aa6633e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6633e",
  null
  
)

export default component.exports